import authTypes from './auth.authTypes';
import storage from '../../helpers/storage';

export default {
  logout(state) {
    localStorage.removeItem('user');
    state.isAuthenticated = false;
    state.type = authTypes.LOGOUT;
  },
  checkAuth(state) {
    const manager = storage.get('manager');
    if (manager && manager.token) {
      state.type = authTypes.CHECK_AUTH_SUCCESS;
      state.data = { ...state.data, ...manager };
      state.isAuthenticated = true;
    } else {
      state.type = authTypes.CHECK_AUTH_FAILED;
      state.error = "User doen't exist";
      state.isAuthenticated = false;
    }
    /*
    if (!!manager && Date.now() < Date.parse(manager.tokenExpiry)) {
      state.type = authTypes.CHECK_AUTH_SUCCESS;
      state.data = { ...state.data, ...manager };
      state.isAuthenticated = true;
    } else if (manager && !Date.now() < Date.parse(manager.tokenExpiry)) {
      state.type = authTypes.CHECK_AUTH_FAILED;
      state.error = 'Token expired';
      state.isAuthenticated = false;
    } else {
      state.type = authTypes.CHECK_AUTH_FAILED;
      state.error = "User doen't exist";
      state.isAuthenticated = false;
    }*/
  },
  [authTypes.SIGNUP_REQUEST](state) {
    state.type = authTypes.SIGNUP_REQUEST;
  },
  [authTypes.SIGNUP_SUCCESS](state, payload) {
    state.type = authTypes.SIGNUP_SUCCESS;
    state.data = { ...state.data, ...payload };
    state.isAuthenticated = true;
  },
  [authTypes.SIGNUP_FAILED](state, payload) {
    state.type = authTypes.SIGNUP_FAILED;
    state.error = payload.error;
    state.isAuthenticated = false;
  },
  [authTypes.LOGIN_REQUEST](state) {
    state.type = authTypes.LOGIN_REQUEST;
  },
  [authTypes.LOGIN_SUCCESS](state, payload) {
    state.type = authTypes.LOGIN_SUCCESS;
    state.data = { ...state.data, ...payload };
    state.isAuthenticated = true;
  },
  [authTypes.LOGIN_BLOCK](state, payload) {
    state.type = authTypes.LOGIN_BLOCK;
    state.data = { ...state.data, ...payload };
    state.isAuthenticated = false;
  },
  [authTypes.LOGIN_FAILED](state, payload) {
    state.type = authTypes.LOGIN_FAILED;
    state.error = payload.error;
    state.isAuthenticated = false;
  },
  [authTypes.RENEW_TOKEN_SUCCESS](state, payload) {
    state.type = authTypes.RENEW_TOKEN_SUCCESS;
    state.data = { ...state.data, ...payload.user };
    state.isAuthenticated = true;
  },
  [authTypes.RENEW_TOKEN_FAILED](state, payload) {
    state.type = authTypes.RENEW_TOKEN_FAILED;
    state.error = payload.error;
  },
  [authTypes.RENEW_TOKEN_REQUEST](state) {
    state.type = authTypes.RENEW_TOKEN_REQUEST;
  }
};
